import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Footer } from '@/components/layout/Footer'
import { ArrowLeft, Shield, CheckCircle2 } from 'lucide-react'

export function About() {
  const { t } = useTranslation()

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-primary-700 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-lg">FJ</span>
            </div>
            <div>
              <h1 className="text-lg font-bold text-slate-900">Flight Journal</h1>
            </div>
          </div>
          <Link
            to="/"
            className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            {t('common.back')}
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1 py-12">
        <div className="max-w-4xl mx-auto px-4">
          <div className="bg-white rounded-lg shadow-sm border border-slate-200 p-8 md:p-12">
            <h1 className="text-4xl font-bold text-slate-900 mb-8">
              {t('legal.about.title')}
            </h1>

            <div className="prose prose-slate max-w-none">
              <p className="text-lg text-slate-700 mb-8">
                {t('legal.about.intro')}
              </p>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-slate-900 mb-4">
                  {t('legal.about.mission.title')}
                </h2>
                <p className="text-slate-700">
                  {t('legal.about.mission.description')}
                </p>
              </section>

              <section className="mb-8">
                <div className="bg-green-50 border border-green-200 rounded-lg p-6">
                  <div className="flex items-start gap-3">
                    <Shield className="w-6 h-6 text-green-700 flex-shrink-0 mt-1" />
                    <div>
                      <h3 className="text-xl font-bold text-green-900 mb-2">
                        {t('legal.about.compliance.title')}
                      </h3>
                      <p className="text-green-800">
                        {t('legal.about.compliance.description')}
                      </p>
                    </div>
                  </div>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-slate-900 mb-4">
                  {t('legal.about.features.title')}
                </h2>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <CheckCircle2 className="w-5 h-5 text-primary-700 flex-shrink-0 mt-0.5" />
                    <span className="text-slate-700">
                      {t('legal.about.features.items.management')}
                    </span>
                  </li>
                  <li className="flex items-start gap-3">
                    <CheckCircle2 className="w-5 h-5 text-primary-700 flex-shrink-0 mt-0.5" />
                    <span className="text-slate-700">
                      {t('legal.about.features.items.tracking')}
                    </span>
                  </li>
                  <li className="flex items-start gap-3">
                    <CheckCircle2 className="w-5 h-5 text-primary-700 flex-shrink-0 mt-0.5" />
                    <span className="text-slate-700">
                      {t('legal.about.features.items.maintenance')}
                    </span>
                  </li>
                  <li className="flex items-start gap-3">
                    <CheckCircle2 className="w-5 h-5 text-primary-700 flex-shrink-0 mt-0.5" />
                    <span className="text-slate-700">
                      {t('legal.about.features.items.reporting')}
                    </span>
                  </li>
                  <li className="flex items-start gap-3">
                    <CheckCircle2 className="w-5 h-5 text-primary-700 flex-shrink-0 mt-0.5" />
                    <span className="text-slate-700">
                      {t('legal.about.features.items.security')}
                    </span>
                  </li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-slate-900 mb-4">
                  {t('legal.about.company.title')}
                </h2>
                <p className="text-slate-700">
                  {t('legal.about.company.description')}
                </p>
              </section>

              <section className="mb-8 bg-slate-50 border border-slate-200 rounded-lg p-6">
                <h2 className="text-2xl font-bold text-slate-900 mb-4">
                  {t('legal.about.contact.title')}
                </h2>
                <p className="text-slate-700 mb-3">
                  {t('legal.about.contact.description')}
                </p>
                <p className="text-slate-700">
                  <strong>{t('footer.contact')}:</strong>{' '}
                  <a
                    href="mailto:acmh360@gmail.com"
                    className="text-primary-700 hover:text-primary-800 underline"
                  >
                    {t('legal.about.contact.email')}
                  </a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}
